import script from "./NewsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewsView.vue?vue&type=script&lang=ts&setup=true"

import "./NewsView.vue?vue&type=style&index=0&id=de8a8aa0&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de8a8aa0"]])

export default __exports__